import React from "react";
import "./LineMaskHero.css";

function LineMaskHero() {
  return (
    <section className="hero-section">
      {/* Tło - 3 slajdy */}
      <div className="hero-slide"></div>
      <div className="hero-slide"></div>
      <div className="hero-slide"></div>

      {/* Tekst */}
      <div className="hero-text">
        <h2>Witam w galerii</h2>
        <p>Zapraszam do zapoznania się z kolekcją!</p>
      </div>
    </section>
  );
}

export default LineMaskHero;